// Generated from ./Restrictions.g4 by ANTLR 4.13.2
// noinspection ES6UnusedImports,JSUnusedGlobalSymbols,JSUnusedLocalSymbols

import {
	ATN,
	ATNDeserializer, DecisionState, DFA, FailedPredicateException,
	RecognitionException, NoViableAltException, BailErrorStrategy,
	Parser, ParserATNSimulator,
	RuleContext, ParserRuleContext, PredictionMode, PredictionContextCache,
	TerminalNode, RuleNode,
	Token, TokenStream,
	Interval, IntervalSet
} from 'antlr4';
import RestrictionsListener from "./RestrictionsListener.js";
import RestrictionsVisitor from "./RestrictionsVisitor.js";

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;

export default class RestrictionsParser extends Parser {
	public static readonly OR = 1;
	public static readonly AND = 2;
	public static readonly EQ = 3;
	public static readonly NEQ = 4;
	public static readonly MATCH = 5;
	public static readonly LPAREN = 6;
	public static readonly RPAREN = 7;
	public static readonly DOLLAR = 8;
	public static readonly POUND = 9;
	public static readonly STR = 10;
	public static readonly WORD = 11;
	public static readonly NUMBER = 12;
	public static readonly WS = 13;
	public static override readonly EOF = Token.EOF;
	public static readonly RULE_parse = 0;
	public static readonly RULE_expr = 1;
	public static readonly RULE_andOr = 2;
	public static readonly RULE_eqNeq = 3;
	public static readonly RULE_term = 4;
	public static readonly RULE_ident = 5;
	public static readonly RULE_ownIdent = 6;
	public static readonly RULE_str = 7;
	public static readonly RULE_word = 8;
	public static readonly RULE_number = 9;
	public static readonly literalNames: (string | null)[] = [ null, "'||'", 
                                                            "'&&'", "'=='", 
                                                            "'!='", "'?'", 
                                                            "'('", "')'", 
                                                            "'$'", "'#'" ];
	public static readonly symbolicNames: (string | null)[] = [ null, "OR", 
                                                             "AND", "EQ", 
                                                             "NEQ", "MATCH", 
                                                             "LPAREN", "RPAREN", 
                                                             "DOLLAR", "POUND", 
                                                             "STR", "WORD", 
                                                             "NUMBER", "WS" ];
	// tslint:disable:no-trailing-whitespace
	public static readonly ruleNames: string[] = [
		"parse", "expr", "andOr", "eqNeq", "term", "ident", "ownIdent", "str", 
		"word", "number",
	];
	public get grammarFileName(): string { return "Restrictions.g4"; }
	public get literalNames(): (string | null)[] { return RestrictionsParser.literalNames; }
	public get symbolicNames(): (string | null)[] { return RestrictionsParser.symbolicNames; }
	public get ruleNames(): string[] { return RestrictionsParser.ruleNames; }
	public get serializedATN(): number[] { return RestrictionsParser._serializedATN; }

	protected createFailedPredicateException(predicate?: string, message?: string): FailedPredicateException {
		return new FailedPredicateException(this, predicate, message);
	}

	constructor(input: TokenStream) {
		super(input);
		this._interp = new ParserATNSimulator(this, RestrictionsParser._ATN, RestrictionsParser.DecisionsToDFA, new PredictionContextCache());
	}
	// @RuleVersion(0)
	public parse(): ParseContext {
		let localctx: ParseContext = new ParseContext(this, this._ctx, this.state);
		this.enterRule(localctx, 0, RestrictionsParser.RULE_parse);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 20;
			this.expr();
			this.state = 21;
			this.match(RestrictionsParser.EOF);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public expr(): ExprContext {
		let localctx: ExprContext = new ExprContext(this, this._ctx, this.state);
		this.enterRule(localctx, 2, RestrictionsParser.RULE_expr);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 23;
			this.andOr(0);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}

	public andOr(): AndOrContext;
	public andOr(_p: number): AndOrContext;
	// @RuleVersion(0)
	public andOr(_p?: number): AndOrContext {
		if (_p === undefined) {
			_p = 0;
		}

		let _parentctx: ParserRuleContext = this._ctx;
		let _parentState: number = this.state;
		let localctx: AndOrContext = new AndOrContext(this, this._ctx, _parentState);
		let _prevctx: AndOrContext = localctx;
		let _startState: number = 4;
		this.enterRecursionRule(localctx, 4, RestrictionsParser.RULE_andOr, _p);
		try {
			let _alt: number;
			this.enterOuterAlt(localctx, 1);
			{
			{
			localctx = new AndOrEqNeqContext(this, localctx);
			this._ctx = localctx;
			_prevctx = localctx;

			this.state = 26;
			this.eqNeq(0);
			}
			this._ctx.stop = this._input.LT(-1);
			this.state = 36;
			this._errHandler.sync(this);
			_alt = this._interp.adaptivePredict(this._input, 1, this._ctx);
			while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
				if (_alt === 1) {
					if (this._parseListeners != null) {
						this.triggerExitRuleEvent();
					}
					_prevctx = localctx;
					{
					this.state = 34;
					this._errHandler.sync(this);
					switch ( this._interp.adaptivePredict(this._input, 0, this._ctx) ) {
					case 1:
						{
						localctx = new AndContext(this, new AndOrContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, RestrictionsParser.RULE_andOr);
						this.state = 28;
						if (!(this.precpred(this._ctx, 2))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 2)");
						}
						this.state = 29;
						this.match(RestrictionsParser.AND);
						this.state = 30;
						this.eqNeq(0);
						}
						break;
					case 2:
						{
						localctx = new OrContext(this, new AndOrContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, RestrictionsParser.RULE_andOr);
						this.state = 31;
						if (!(this.precpred(this._ctx, 1))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 1)");
						}
						this.state = 32;
						this.match(RestrictionsParser.OR);
						this.state = 33;
						this.eqNeq(0);
						}
						break;
					}
					}
				}
				this.state = 38;
				this._errHandler.sync(this);
				_alt = this._interp.adaptivePredict(this._input, 1, this._ctx);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.unrollRecursionContexts(_parentctx);
		}
		return localctx;
	}

	public eqNeq(): EqNeqContext;
	public eqNeq(_p: number): EqNeqContext;
	// @RuleVersion(0)
	public eqNeq(_p?: number): EqNeqContext {
		if (_p === undefined) {
			_p = 0;
		}

		let _parentctx: ParserRuleContext = this._ctx;
		let _parentState: number = this.state;
		let localctx: EqNeqContext = new EqNeqContext(this, this._ctx, _parentState);
		let _prevctx: EqNeqContext = localctx;
		let _startState: number = 6;
		this.enterRecursionRule(localctx, 6, RestrictionsParser.RULE_eqNeq, _p);
		try {
			let _alt: number;
			this.enterOuterAlt(localctx, 1);
			{
			{
			localctx = new EqNeqTermContext(this, localctx);
			this._ctx = localctx;
			_prevctx = localctx;

			this.state = 40;
			this.term();
			}
			this._ctx.stop = this._input.LT(-1);
			this.state = 53;
			this._errHandler.sync(this);
			_alt = this._interp.adaptivePredict(this._input, 3, this._ctx);
			while (_alt !== 2 && _alt !== ATN.INVALID_ALT_NUMBER) {
				if (_alt === 1) {
					if (this._parseListeners != null) {
						this.triggerExitRuleEvent();
					}
					_prevctx = localctx;
					{
					this.state = 51;
					this._errHandler.sync(this);
					switch ( this._interp.adaptivePredict(this._input, 2, this._ctx) ) {
					case 1:
						{
						localctx = new EqContext(this, new EqNeqContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, RestrictionsParser.RULE_eqNeq);
						this.state = 42;
						if (!(this.precpred(this._ctx, 3))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 3)");
						}
						this.state = 43;
						this.match(RestrictionsParser.EQ);
						this.state = 44;
						this.term();
						}
						break;
					case 2:
						{
						localctx = new NeqContext(this, new EqNeqContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, RestrictionsParser.RULE_eqNeq);
						this.state = 45;
						if (!(this.precpred(this._ctx, 2))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 2)");
						}
						this.state = 46;
						this.match(RestrictionsParser.NEQ);
						this.state = 47;
						this.term();
						}
						break;
					case 3:
						{
						localctx = new MatchContext(this, new EqNeqContext(this, _parentctx, _parentState));
						this.pushNewRecursionContext(localctx, _startState, RestrictionsParser.RULE_eqNeq);
						this.state = 48;
						if (!(this.precpred(this._ctx, 1))) {
							throw this.createFailedPredicateException("this.precpred(this._ctx, 1)");
						}
						this.state = 49;
						this.match(RestrictionsParser.MATCH);
						this.state = 50;
						this.term();
						}
						break;
					}
					}
				}
				this.state = 55;
				this._errHandler.sync(this);
				_alt = this._interp.adaptivePredict(this._input, 3, this._ctx);
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.unrollRecursionContexts(_parentctx);
		}
		return localctx;
	}
	// @RuleVersion(0)
	public term(): TermContext {
		let localctx: TermContext = new TermContext(this, this._ctx, this.state);
		this.enterRule(localctx, 8, RestrictionsParser.RULE_term);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 64;
			this._errHandler.sync(this);
			switch ( this._interp.adaptivePredict(this._input, 4, this._ctx) ) {
			case 1:
				{
				this.state = 56;
				this.ident();
				}
				break;
			case 2:
				{
				this.state = 57;
				this.ownIdent();
				}
				break;
			case 3:
				{
				this.state = 58;
				this.number_();
				}
				break;
			case 4:
				{
				this.state = 59;
				this.str();
				}
				break;
			case 5:
				{
				this.state = 60;
				this.match(RestrictionsParser.LPAREN);
				this.state = 61;
				this.andOr(0);
				this.state = 62;
				this.match(RestrictionsParser.RPAREN);
				}
				break;
			}
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public ident(): IdentContext {
		let localctx: IdentContext = new IdentContext(this, this._ctx, this.state);
		this.enterRule(localctx, 10, RestrictionsParser.RULE_ident);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 66;
			this.match(RestrictionsParser.DOLLAR);
			this.state = 67;
			this.word();
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public ownIdent(): OwnIdentContext {
		let localctx: OwnIdentContext = new OwnIdentContext(this, this._ctx, this.state);
		this.enterRule(localctx, 12, RestrictionsParser.RULE_ownIdent);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 69;
			this.match(RestrictionsParser.POUND);
			this.state = 70;
			this.word();
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public str(): StrContext {
		let localctx: StrContext = new StrContext(this, this._ctx, this.state);
		this.enterRule(localctx, 14, RestrictionsParser.RULE_str);
		let _la: number;
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 75;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			while (_la===13) {
				{
				{
				this.state = 72;
				this.match(RestrictionsParser.WS);
				}
				}
				this.state = 77;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
			}
			this.state = 78;
			this.match(RestrictionsParser.STR);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public word(): WordContext {
		let localctx: WordContext = new WordContext(this, this._ctx, this.state);
		this.enterRule(localctx, 16, RestrictionsParser.RULE_word);
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 80;
			this.match(RestrictionsParser.WORD);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}
	// @RuleVersion(0)
	public number_(): NumberContext {
		let localctx: NumberContext = new NumberContext(this, this._ctx, this.state);
		this.enterRule(localctx, 18, RestrictionsParser.RULE_number);
		let _la: number;
		try {
			this.enterOuterAlt(localctx, 1);
			{
			this.state = 85;
			this._errHandler.sync(this);
			_la = this._input.LA(1);
			while (_la===13) {
				{
				{
				this.state = 82;
				this.match(RestrictionsParser.WS);
				}
				}
				this.state = 87;
				this._errHandler.sync(this);
				_la = this._input.LA(1);
			}
			this.state = 88;
			this.match(RestrictionsParser.NUMBER);
			}
		}
		catch (re) {
			if (re instanceof RecognitionException) {
				localctx.exception = re;
				this._errHandler.reportError(this, re);
				this._errHandler.recover(this, re);
			} else {
				throw re;
			}
		}
		finally {
			this.exitRule();
		}
		return localctx;
	}

	public sempred(localctx: RuleContext, ruleIndex: number, predIndex: number): boolean {
		switch (ruleIndex) {
		case 2:
			return this.andOr_sempred(localctx as AndOrContext, predIndex);
		case 3:
			return this.eqNeq_sempred(localctx as EqNeqContext, predIndex);
		}
		return true;
	}
	private andOr_sempred(localctx: AndOrContext, predIndex: number): boolean {
		switch (predIndex) {
		case 0:
			return this.precpred(this._ctx, 2);
		case 1:
			return this.precpred(this._ctx, 1);
		}
		return true;
	}
	private eqNeq_sempred(localctx: EqNeqContext, predIndex: number): boolean {
		switch (predIndex) {
		case 2:
			return this.precpred(this._ctx, 3);
		case 3:
			return this.precpred(this._ctx, 2);
		case 4:
			return this.precpred(this._ctx, 1);
		}
		return true;
	}

	public static readonly _serializedATN: number[] = [4,1,13,91,2,0,7,0,2,
	1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,1,
	0,1,0,1,0,1,1,1,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,5,2,35,8,2,10,2,12,
	2,38,9,2,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,5,3,52,8,3,10,
	3,12,3,55,9,3,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,3,4,65,8,4,1,5,1,5,1,5,1,
	6,1,6,1,6,1,7,5,7,74,8,7,10,7,12,7,77,9,7,1,7,1,7,1,8,1,8,1,9,5,9,84,8,
	9,10,9,12,9,87,9,9,1,9,1,9,1,9,0,2,4,6,10,0,2,4,6,8,10,12,14,16,18,0,0,
	91,0,20,1,0,0,0,2,23,1,0,0,0,4,25,1,0,0,0,6,39,1,0,0,0,8,64,1,0,0,0,10,
	66,1,0,0,0,12,69,1,0,0,0,14,75,1,0,0,0,16,80,1,0,0,0,18,85,1,0,0,0,20,21,
	3,2,1,0,21,22,5,0,0,1,22,1,1,0,0,0,23,24,3,4,2,0,24,3,1,0,0,0,25,26,6,2,
	-1,0,26,27,3,6,3,0,27,36,1,0,0,0,28,29,10,2,0,0,29,30,5,2,0,0,30,35,3,6,
	3,0,31,32,10,1,0,0,32,33,5,1,0,0,33,35,3,6,3,0,34,28,1,0,0,0,34,31,1,0,
	0,0,35,38,1,0,0,0,36,34,1,0,0,0,36,37,1,0,0,0,37,5,1,0,0,0,38,36,1,0,0,
	0,39,40,6,3,-1,0,40,41,3,8,4,0,41,53,1,0,0,0,42,43,10,3,0,0,43,44,5,3,0,
	0,44,52,3,8,4,0,45,46,10,2,0,0,46,47,5,4,0,0,47,52,3,8,4,0,48,49,10,1,0,
	0,49,50,5,5,0,0,50,52,3,8,4,0,51,42,1,0,0,0,51,45,1,0,0,0,51,48,1,0,0,0,
	52,55,1,0,0,0,53,51,1,0,0,0,53,54,1,0,0,0,54,7,1,0,0,0,55,53,1,0,0,0,56,
	65,3,10,5,0,57,65,3,12,6,0,58,65,3,18,9,0,59,65,3,14,7,0,60,61,5,6,0,0,
	61,62,3,4,2,0,62,63,5,7,0,0,63,65,1,0,0,0,64,56,1,0,0,0,64,57,1,0,0,0,64,
	58,1,0,0,0,64,59,1,0,0,0,64,60,1,0,0,0,65,9,1,0,0,0,66,67,5,8,0,0,67,68,
	3,16,8,0,68,11,1,0,0,0,69,70,5,9,0,0,70,71,3,16,8,0,71,13,1,0,0,0,72,74,
	5,13,0,0,73,72,1,0,0,0,74,77,1,0,0,0,75,73,1,0,0,0,75,76,1,0,0,0,76,78,
	1,0,0,0,77,75,1,0,0,0,78,79,5,10,0,0,79,15,1,0,0,0,80,81,5,11,0,0,81,17,
	1,0,0,0,82,84,5,13,0,0,83,82,1,0,0,0,84,87,1,0,0,0,85,83,1,0,0,0,85,86,
	1,0,0,0,86,88,1,0,0,0,87,85,1,0,0,0,88,89,5,12,0,0,89,19,1,0,0,0,7,34,36,
	51,53,64,75,85];

	private static __ATN: ATN;
	public static get _ATN(): ATN {
		if (!RestrictionsParser.__ATN) {
			RestrictionsParser.__ATN = new ATNDeserializer().deserialize(RestrictionsParser._serializedATN);
		}

		return RestrictionsParser.__ATN;
	}


	static DecisionsToDFA = RestrictionsParser._ATN.decisionToState.map( (ds: DecisionState, index: number) => new DFA(ds, index) );

}

export class ParseContext extends ParserRuleContext {
	constructor(parser?: RestrictionsParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public expr(): ExprContext {
		return this.getTypedRuleContext(ExprContext, 0) as ExprContext;
	}
	public EOF(): TerminalNode {
		return this.getToken(RestrictionsParser.EOF, 0);
	}
    public get ruleIndex(): number {
    	return RestrictionsParser.RULE_parse;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterParse) {
	 		listener.enterParse(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitParse) {
	 		listener.exitParse(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitParse) {
			return visitor.visitParse(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class ExprContext extends ParserRuleContext {
	constructor(parser?: RestrictionsParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public andOr(): AndOrContext {
		return this.getTypedRuleContext(AndOrContext, 0) as AndOrContext;
	}
    public get ruleIndex(): number {
    	return RestrictionsParser.RULE_expr;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterExpr) {
	 		listener.enterExpr(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitExpr) {
	 		listener.exitExpr(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitExpr) {
			return visitor.visitExpr(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class AndOrContext extends ParserRuleContext {
	constructor(parser?: RestrictionsParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return RestrictionsParser.RULE_andOr;
	}
	public override copyFrom(ctx: AndOrContext): void {
		super.copyFrom(ctx);
	}
}
export class AndOrEqNeqContext extends AndOrContext {
	constructor(parser: RestrictionsParser, ctx: AndOrContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public eqNeq(): EqNeqContext {
		return this.getTypedRuleContext(EqNeqContext, 0) as EqNeqContext;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterAndOrEqNeq) {
	 		listener.enterAndOrEqNeq(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitAndOrEqNeq) {
	 		listener.exitAndOrEqNeq(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitAndOrEqNeq) {
			return visitor.visitAndOrEqNeq(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class OrContext extends AndOrContext {
	constructor(parser: RestrictionsParser, ctx: AndOrContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public andOr(): AndOrContext {
		return this.getTypedRuleContext(AndOrContext, 0) as AndOrContext;
	}
	public OR(): TerminalNode {
		return this.getToken(RestrictionsParser.OR, 0);
	}
	public eqNeq(): EqNeqContext {
		return this.getTypedRuleContext(EqNeqContext, 0) as EqNeqContext;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterOr) {
	 		listener.enterOr(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitOr) {
	 		listener.exitOr(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitOr) {
			return visitor.visitOr(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class AndContext extends AndOrContext {
	constructor(parser: RestrictionsParser, ctx: AndOrContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public andOr(): AndOrContext {
		return this.getTypedRuleContext(AndOrContext, 0) as AndOrContext;
	}
	public AND(): TerminalNode {
		return this.getToken(RestrictionsParser.AND, 0);
	}
	public eqNeq(): EqNeqContext {
		return this.getTypedRuleContext(EqNeqContext, 0) as EqNeqContext;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterAnd) {
	 		listener.enterAnd(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitAnd) {
	 		listener.exitAnd(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitAnd) {
			return visitor.visitAnd(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class EqNeqContext extends ParserRuleContext {
	constructor(parser?: RestrictionsParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
    public get ruleIndex(): number {
    	return RestrictionsParser.RULE_eqNeq;
	}
	public override copyFrom(ctx: EqNeqContext): void {
		super.copyFrom(ctx);
	}
}
export class MatchContext extends EqNeqContext {
	constructor(parser: RestrictionsParser, ctx: EqNeqContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public eqNeq(): EqNeqContext {
		return this.getTypedRuleContext(EqNeqContext, 0) as EqNeqContext;
	}
	public MATCH(): TerminalNode {
		return this.getToken(RestrictionsParser.MATCH, 0);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterMatch) {
	 		listener.enterMatch(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitMatch) {
	 		listener.exitMatch(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitMatch) {
			return visitor.visitMatch(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class NeqContext extends EqNeqContext {
	constructor(parser: RestrictionsParser, ctx: EqNeqContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public eqNeq(): EqNeqContext {
		return this.getTypedRuleContext(EqNeqContext, 0) as EqNeqContext;
	}
	public NEQ(): TerminalNode {
		return this.getToken(RestrictionsParser.NEQ, 0);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterNeq) {
	 		listener.enterNeq(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitNeq) {
	 		listener.exitNeq(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitNeq) {
			return visitor.visitNeq(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class EqContext extends EqNeqContext {
	constructor(parser: RestrictionsParser, ctx: EqNeqContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public eqNeq(): EqNeqContext {
		return this.getTypedRuleContext(EqNeqContext, 0) as EqNeqContext;
	}
	public EQ(): TerminalNode {
		return this.getToken(RestrictionsParser.EQ, 0);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterEq) {
	 		listener.enterEq(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitEq) {
	 		listener.exitEq(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitEq) {
			return visitor.visitEq(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
export class EqNeqTermContext extends EqNeqContext {
	constructor(parser: RestrictionsParser, ctx: EqNeqContext) {
		super(parser, ctx.parentCtx, ctx.invokingState);
		super.copyFrom(ctx);
	}
	public term(): TermContext {
		return this.getTypedRuleContext(TermContext, 0) as TermContext;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterEqNeqTerm) {
	 		listener.enterEqNeqTerm(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitEqNeqTerm) {
	 		listener.exitEqNeqTerm(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitEqNeqTerm) {
			return visitor.visitEqNeqTerm(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class TermContext extends ParserRuleContext {
	constructor(parser?: RestrictionsParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public ident(): IdentContext {
		return this.getTypedRuleContext(IdentContext, 0) as IdentContext;
	}
	public ownIdent(): OwnIdentContext {
		return this.getTypedRuleContext(OwnIdentContext, 0) as OwnIdentContext;
	}
	public number_(): NumberContext {
		return this.getTypedRuleContext(NumberContext, 0) as NumberContext;
	}
	public str(): StrContext {
		return this.getTypedRuleContext(StrContext, 0) as StrContext;
	}
	public LPAREN(): TerminalNode {
		return this.getToken(RestrictionsParser.LPAREN, 0);
	}
	public andOr(): AndOrContext {
		return this.getTypedRuleContext(AndOrContext, 0) as AndOrContext;
	}
	public RPAREN(): TerminalNode {
		return this.getToken(RestrictionsParser.RPAREN, 0);
	}
    public get ruleIndex(): number {
    	return RestrictionsParser.RULE_term;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterTerm) {
	 		listener.enterTerm(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitTerm) {
	 		listener.exitTerm(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitTerm) {
			return visitor.visitTerm(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class IdentContext extends ParserRuleContext {
	constructor(parser?: RestrictionsParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public DOLLAR(): TerminalNode {
		return this.getToken(RestrictionsParser.DOLLAR, 0);
	}
	public word(): WordContext {
		return this.getTypedRuleContext(WordContext, 0) as WordContext;
	}
    public get ruleIndex(): number {
    	return RestrictionsParser.RULE_ident;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterIdent) {
	 		listener.enterIdent(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitIdent) {
	 		listener.exitIdent(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitIdent) {
			return visitor.visitIdent(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class OwnIdentContext extends ParserRuleContext {
	constructor(parser?: RestrictionsParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public POUND(): TerminalNode {
		return this.getToken(RestrictionsParser.POUND, 0);
	}
	public word(): WordContext {
		return this.getTypedRuleContext(WordContext, 0) as WordContext;
	}
    public get ruleIndex(): number {
    	return RestrictionsParser.RULE_ownIdent;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterOwnIdent) {
	 		listener.enterOwnIdent(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitOwnIdent) {
	 		listener.exitOwnIdent(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitOwnIdent) {
			return visitor.visitOwnIdent(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class StrContext extends ParserRuleContext {
	constructor(parser?: RestrictionsParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public STR(): TerminalNode {
		return this.getToken(RestrictionsParser.STR, 0);
	}
	public WS_list(): TerminalNode[] {
	    	return this.getTokens(RestrictionsParser.WS);
	}
	public WS(i: number): TerminalNode {
		return this.getToken(RestrictionsParser.WS, i);
	}
    public get ruleIndex(): number {
    	return RestrictionsParser.RULE_str;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterStr) {
	 		listener.enterStr(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitStr) {
	 		listener.exitStr(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitStr) {
			return visitor.visitStr(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class WordContext extends ParserRuleContext {
	constructor(parser?: RestrictionsParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public WORD(): TerminalNode {
		return this.getToken(RestrictionsParser.WORD, 0);
	}
    public get ruleIndex(): number {
    	return RestrictionsParser.RULE_word;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterWord) {
	 		listener.enterWord(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitWord) {
	 		listener.exitWord(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitWord) {
			return visitor.visitWord(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}


export class NumberContext extends ParserRuleContext {
	constructor(parser?: RestrictionsParser, parent?: ParserRuleContext, invokingState?: number) {
		super(parent, invokingState);
    	this.parser = parser;
	}
	public NUMBER(): TerminalNode {
		return this.getToken(RestrictionsParser.NUMBER, 0);
	}
	public WS_list(): TerminalNode[] {
	    	return this.getTokens(RestrictionsParser.WS);
	}
	public WS(i: number): TerminalNode {
		return this.getToken(RestrictionsParser.WS, i);
	}
    public get ruleIndex(): number {
    	return RestrictionsParser.RULE_number;
	}
	public enterRule(listener: RestrictionsListener): void {
	    if(listener.enterNumber) {
	 		listener.enterNumber(this);
		}
	}
	public exitRule(listener: RestrictionsListener): void {
	    if(listener.exitNumber) {
	 		listener.exitNumber(this);
		}
	}
	// @Override
	public accept<Result>(visitor: RestrictionsVisitor<Result>): Result {
		if (visitor.visitNumber) {
			return visitor.visitNumber(this);
		} else {
			return visitor.visitChildren(this);
		}
	}
}
